




























































import { Component, Vue } from 'vue-property-decorator';
import { getProblemLog, getDetail, queryCurrent } from '@/api/user/user';
import { DOMAIN } from '@/global/constants';
import { goTop } from '@/global/utils';

@Component
export default class AnswerTags extends Vue {
  private columns: object[] = [
    {
      title: '任务id',
      key: 'mid',
      width: '120',
      align: 'center',
    },
    {
      title: '用户id',
      key: 'uid',
      width: '120',
      align: 'center',
    },
    {
      title: '题目id',
      key: 'lid',
      width: '120',
      align: 'center',
    },
    {
      title: '时间',
      key: 'time',
      width: '220',
      align: 'center',
    },
    {
      title: '状态',
      slot: 'status',
      align: 'center',
    },
    {
      title: '查看详情',
      slot: 'check',
      align: 'center',
      width: '150',
    },
  ];
  private columnsLog: object[] = [
    {
      title: '题目id',
      key: 'lid',
      align: 'center',
    },
    {
      title: '任务id',
      key: 'mid',
      align: 'center',
    },
    {
      title: '操作人id',
      key: 'uid',
      align: 'center',
    },
    {
      title: '任务类型',
      key: 'type',
      align: 'center',
    },
    {
      title: '时间',
      key: 'time',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'operate',
      align: 'center',
    },
  ];
  private loading: boolean = true;
  // 列表请求参数
  private dataOption: object = {
    page: 1,
    rows: 20,
    uid: this.$store.state.userInfo.id || -1,
  };
  private total: number = 0;
  private tableData: object[] = [];
  private tablelog: object[] = [];
  private created() {
    if ((this.dataOption as any).uid > -1) {
      this.getListData({ ...this.dataOption });
    } else {
      this.getUserInfo();
    }
    goTop();
  }
  private async getUserInfo() {
    try {
      const res: any = await queryCurrent('');
      if (typeof res !== 'string') {
        this.$store.commit('setUser', res);
        this.$store.dispatch('getRecentList');
        (this.dataOption as any).uid = res.id;
        this.getListData({ ...this.dataOption });
      } else {
        this.$router.push({ path: 'login' });
      }
    } catch (err) {
      this.$router.push({ path: 'login' });
    }
  }
  // 获取表格数据
  private async getListData(option) {
    try {
      this.loading = true;
      const res = await getProblemLog(option);
      this.tablelog = [];
      if ((res as any).rows.length > 0) {
        this.tableData = (res as any).rows;
      }
      this.total = (res as any).total;
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  }

  // 获取表格日志
  private async getListLog(option) {
    try {
      this.loading = true;
      const res = await getProblemLog(option);
      this.tableData = [];
      if ((res as any).rows.length > 0) {
        this.tablelog = (res as any).rows;
      }
      this.total = (res as any).total;
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  }

  // 查看结果
  private async openDetail(mid: number) {
    try {
      const res = await getDetail({ mlid: mid });
      const result = res as any;
      let from = result.module.from;
      if (from.indexOf('sketch') > -1) {
        from = from.indexOf('-') > -1 ? from.split('-')[1] : 'markPage';
      }
      window.open(
        `${DOMAIN}/tools/${from}.html?type=56&qid=${result.mlid}&inspectmid=${result.mid}`
      );
    } catch (err) {
      console.log(err);
    }
  }
  // 分页
  private async changePage(num: number) {
    (this.dataOption as any).page = num;
    if ((this.dataOption as any).uid > -1) {
      this.getListData({ ...this.dataOption });
      goTop();
    }
  }
  // 全部日志
  private getProblemLog(id: number) {
    this.getListLog({
      page: 1,
      rows: 20,
      lid: id,
    });
    goTop();
  }
  // 返回
  private changeStatus() {
    if ((this.dataOption as any).uid > -1) {
      (this.dataOption as any).page = 1;
      this.getListData({ ...this.dataOption });
    }
  }
  // 查询任务id
  private handleSearch(id: number) {
    if (id) {
      const dataOption = this.dataOption as any;
      dataOption.mid = id;
      dataOption.page = 1;
      this.getListData({ ...dataOption });
    } else {
      const dataOption = this.dataOption as any;
      if (dataOption.mid) {
        delete dataOption.mid;
      }
      dataOption.page = 1;
      this.getListData({ ...dataOption });
    }
  }
}
